/* eslint-disable */
require('@/utils/extensions');

var setFieldValue = function (object, path, value) {
    var pathArr = path.replace(/^\./, '').split('.');
    return pathArr.reduce(
        function (obj, prop, indx) {
            if (typeof obj !== "undefined" && obj != null && (indx + 1) === pathArr.length) {
                obj[prop] = value;
                //console.log("obj ", obj, "  obj[prop] ",  obj[prop], "  value ", value);
            }
            if(typeof obj === "undefined")
                return null;
            return obj[prop] || obj;
        }, object);

};

var getKeyValuePair = function (key, value) {
    return { "key": key, "value": value };
};

var getRiskLabelByProp = function (key, value, arr) {
    return arr.findItem(key, value);
};

var getIntArr = function (max, start, sort = "desc", startWithNone = "0") {
    var min = max - start;
    var intArr = [];

    if (sort != "desc") {
        for (var j = min; j <= max; j++) {
            startWithNone == "1" && j === 0 ? intArr.push('None') : intArr.push(j);
        }
        return intArr;
    }

    intArr = [];
    for (var i = max; i >= min; i--) {
        startWithNone == "1" && i === 0 ? intArr.push('None') : intArr.push(i);
    }
    return intArr;
};

var scrollToTop = function (id) {
    var form = document.getElementById(id);
    var fixedHeaderHeight = 180;
    if (form != null) {
        //var top = form.offsetTop;
        var top = 0;
        window.scrollTo({
            top: top,
            left: 0,
            behavior: 'smooth'
        });
    }
};

var clearDateInput = function (key) {
    var dateContainer = document.getElementById(key);

    if (dateContainer === null) return;

    var dateInput = dateContainer.getElementsByTagName("input")[1];
    if (dateInput !== null) {
        dateInput.value = "";
    }
};
var clearRadio = function (key) {
    var radios = document.getElementsByName(key);
    if (radios !== null && radios.length > 0) {
        for (var i = 0; i < radios.length; i++) {
            if (radios[i].type === 'radio') {
                radios[i].checked = false;
            }
        }
    }
};
var validateBeforeSubmit = function (event, callback) {
    event.preventDefault();
    this.validate("page-form", this.validations);

    if (typeof callback !== "undefined" && this.errors.length === 0) {
        this.canProceed = true;
        callback();
        return;
    }

    this.canProceed = false;
    this.scrollToTop("page-form");
};

var redirectToRoute = function (route) {
    setTimeout(() => {
        this.$router.push(route);
    }, 2000);
};

var generateUniqueString = () => {
    return 'JD' + Math.random().toString(36).substr(2, 12).toUpperCase();
};

var gerenateRandomNumber = (min, max) => {
    var random = Math.floor(Math.random() * (max - min + 1)) + min;
    return random;
};
var getAddressLine = function (line) {
    return line != null && line.length > 0 ? line + ', ' : '';
};
var formatAddress = function (address) {
    var formattedAddress =
        address.addressLine1 + ", " + this.getAddressLine(address.addressLine2) +
        this.getAddressLine(address.addressLine3) + address.town + ",<br />" +
        address.postcode;

    return formattedAddress;

};
export default {

    data() {
        return {
          notificationStatusCode: {
            error: 0,
            success: 1,
            info: 2,
          },
        }
    },
    methods: {
        getKeyValuePair,
        getIntArr,
        scrollToTop,
        validateBeforeSubmit,
        clearDateInput,
        clearRadio,
        getRiskLabelByProp,
        redirectToRoute,
        setFieldValue,
        generateUniqueString,
        gerenateRandomNumber,
        getAddressLine,
        formatAddress
    }
};

